import { db, FirebaseDocRefType } from 'firebase/index'
import { useEffect, useState } from 'react'

const useQueryStoreNameByBreadRef = (breadRef: FirebaseDocRefType) => {
  const [storeName, setStoreName] = useState<string>('')
  useEffect(() => {
    if (!breadRef) return
    db.collectionGroup('store_breads')
      .where('bread_ref', '==', breadRef)
      .get()
      .then(async (snapshots) => {
        const snapshot = snapshots.docs[0]
        if (!snapshot) return
        snapshot.ref.parent.parent?.get().then((storeSnapshot) => {
          const data = storeSnapshot.data()
          if (!data || !('name' in data)) return
          setStoreName(data.name)
        })
      })
  }, [breadRef])
  return storeName
}

export default useQueryStoreNameByBreadRef
